// extracted by mini-css-extract-plugin
module.exports = {"Permissions":"selectemployee_Permissions__1v2-n","TableCol":"selectemployee_TableCol__2599P","Button":"selectemployee_Button__3ofI5"};